import React from "react";
import { IconsProps } from "./Icons";

export const SentimentIconDash = ({
  className,
  fill,
  width,
  height,
  viewBox,
}: IconsProps) => {
  return (
    <svg
      className={className}
      width={width || "40"}
      height={height || "40"}
      viewBox={viewBox || "0 0 40 40"}
      fill={fill || "None"}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.11111 5.23606H5.55556C4.61256 5.23606 3.70819 5.60869 3.0414 6.27198C2.3746 6.93526 2 7.83487 2 8.7729V29.994C2 30.932 2.3746 31.8316 3.0414 32.4949C3.70819 33.1582 4.61256 33.5308 5.55556 33.5308H15.6836M9.11111 5.23606C9.11111 4.29803 9.48571 3.39842 10.1525 2.73514C10.8193 2.07185 11.7237 1.69922 12.6667 1.69922H16.2222C17.1652 1.69922 18.0696 2.07185 18.7364 2.73514C19.4032 3.39842 19.7778 4.29803 19.7778 5.23606M9.11111 5.23606C9.11111 6.17409 9.48571 7.0737 10.1525 7.73699C10.8193 8.40027 11.7237 8.7729 12.6667 8.7729H16.2222C17.1652 8.7729 18.0696 8.40027 18.7364 7.73699C19.4032 7.0737 19.7778 6.17409 19.7778 5.23606M26.8889 21.1518C28.7749 21.1518 30.5836 21.8971 31.9172 23.2237C33.2508 24.5503 34 26.3495 34 28.2255M26.8889 21.1518C25.0029 21.1518 23.1942 21.8971 21.8606 23.2237C20.527 24.5503 19.7778 26.3495 19.7778 28.2255C19.7778 30.1016 20.527 31.9008 21.8606 33.2274C23.1942 34.554 25.0029 35.2992 26.8889 35.2992C28.7749 35.2992 30.5836 34.554 31.9172 33.2274C33.2508 31.9008 34 30.1016 34 28.2255M26.8889 21.1518V24.6887V28.2255H34M26.8889 15.8466V8.7729C26.8889 7.83487 26.5143 6.93526 25.8475 6.27198C25.1807 5.60869 24.2763 5.23606 23.3333 5.23606H19.7778M9.11111 15.8466H16.2222M9.11111 22.9203H14.4444"
        stroke="#8626C0"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
